export const NUMBER_OF_REVIEWS_ON_ADAPTIVE = 3;
